import { http as supportHttp } from './http'

export const getSupportFaqs = () => supportHttp.get('/support/faqs')

export const getSupportFaqAnswer = id => supportHttp.get(`/support/faqs/${id}`)

export const getOpenApiDoc = () => supportHttp.get('/support/openApiDoc')
